import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';
import { TASK_COUNT_FEATURE_KEY, TaskCountState } from './task-count.reducer';
import { CallState, getError, LoadingState } from '@lyceo/shared/util-loading';
import { TaskCounts } from '@lyceo/shared/task-count/util';

export const selectTaskCountState: MemoizedSelector<object, TaskCountState> =
  createFeatureSelector<TaskCountState>(TASK_COUNT_FEATURE_KEY);

export const selectCountCallState = createSelector(
  selectTaskCountState,
  (state: TaskCountState) => state.countCallState,
);

export const selectCountLoading = createSelector(
  selectCountCallState,
  (callState: CallState) => callState === LoadingState.LOADING,
);

export const selectCountError = createSelector(
  selectCountCallState,
  (callState: CallState) => getError(callState),
);

export const selectTaskCounts = createSelector(
  selectTaskCountState,
  (state: TaskCountState) => state.taskCounts,
);

export const selectTaskToPlan = createSelector(
  selectTaskCounts,
  (taskCounts: TaskCounts) => taskCounts.tasksToPlan,
);
